import { Link } from "react-router-dom";
import { MapPin, ArrowUpRight } from "lucide-react";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="main-footer" className="relative bg-ink text-background border-t border-background/15 overflow-hidden">
      <div className="absolute inset-0 dotted-grid opacity-10" aria-hidden />
      <div className="relative mx-auto max-w-[1400px] px-6 lg:px-12 py-20">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <span className="grid place-items-center h-9 w-9 rounded-full bg-primary text-primary-foreground font-display font-semibold">J</span>
              <span className="font-display text-[15px] font-semibold tracking-[0.18em] uppercase">JLY Services</span>
            </div>
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-background/60">
              Independent brokerage and technology studio helping households and
              trades make smarter decisions on solar, batteries and essential
              services.
            </p>
            <div className="mt-8 space-y-2 text-sm text-background/70">
              <p className="flex items-center gap-2" data-testid="footer-address">
                <MapPin className="h-4 w-4 text-accent-warm" /> Australia
              </p>
            </div>
          </div>

          <div className="lg:col-span-3 lg:col-start-8">
            <h4 className="text-[11px] tracking-[0.24em] uppercase font-semibold text-background/50">Explore</h4>
            <ul className="mt-5 space-y-3 text-sm">
              {[["Services", "/#services"], ["Ethos", "/#ethos"], ["Apps", "/#apps"], ["Contact", "/#contact"]].map(([label, href]) => (
                <li key={label}>
                  <a href={href} data-testid={`footer-link-${label.toLowerCase()}`} className="group inline-flex items-center gap-1 text-background/75 hover:text-background transition-colors">
                    {label}
                    <ArrowUpRight className="h-3.5 w-3.5 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-200" />
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="text-[11px] tracking-[0.24em] uppercase font-semibold text-background/50">Legal</h4>
            <ul className="mt-5 space-y-3 text-sm">
              <li><Link to="/privacy" data-testid="footer-link-privacy" className="text-background/75 hover:text-background transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" data-testid="footer-link-terms" className="text-background/75 hover:text-background transition-colors">Terms of Service</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-background/15 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background/50" data-testid="footer-copyright">&copy; {year} JLY Services. All rights reserved.</p>
          <p className="text-xs text-background/50">ABN / business details available on request.</p>
        </div>
      </div>
    </footer>
  );
};
